import { render, staticRenderFns } from "./ViewProduction.vue?vue&type=template&id=089be070&"
import script from "./ViewProduction.vue?vue&type=script&lang=js&"
export * from "./ViewProduction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports